<script>
export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
